module.exports = __webpack_public_path__ + "static/media/tekura5.8766d21d.jpg";